import React from 'react';

interface ApproveButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  variant?: 'approve' | 'reject';
}

const ApproveButton: React.FC<ApproveButtonProps> = ({ 
  onClick, 
  children, 
  disabled = false,
  className = '',
  variant = 'approve'
}) => {
  return (
    <button 
      className={`approve ${variant} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ApproveButton; 